import { LOAD_PICDATA, LOAD_PICDATA_SUCCESS, LOAD_PICDATA_ERROR } from 'containers/HomePage/constants';
import {picdata} from 'Interfaces/picdata';

export interface ILoadPicdataAction {
  type: typeof LOAD_PICDATA;
}

export interface IPicdataLoaded {
  type: typeof LOAD_PICDATA_SUCCESS;
  picdata: picdata[];
}

export interface IPicdataLoadingError {
  type: typeof LOAD_PICDATA_ERROR;
  error: any;
}

export function loadPicdata(): ILoadPicdataAction {
  return {
    type: LOAD_PICDATA,
  };
}

export function picdataLoaded(data: picdata[]): IPicdataLoaded {
  return {
    type: LOAD_PICDATA_SUCCESS,
    picdata: data
  };
}

export function hitokotoLoadingError(error: any): IPicdataLoadingError {
  return {
    type: LOAD_PICDATA_ERROR,
    error
  };
}



// WEBPACK FOOTER //
// ./src/containers/HomePage/actions.ts